import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./LogoCarousel.css"; // External CSS file
import Images from "../../constant/images";

const logos = [
  Images.cvarogel5,
  Images.cvarogel4,
  Images.cvarogel3,
  Images.cvarogel5,
  Images.cvarogel4,
  Images.cvarogel5,
  Images.cvarogel3,
  Images.cvarogel5,
  Images.cvarogel3,
  Images.cvarogel5,
  Images.cvarogel4,
  Images.cvarogel5,
  Images.cvarogel3,
  Images.cvarogel5,
  Images.cvarogel4,
  Images.cvarogel5,
  Images.cvarogel3,
  Images.cvarogel5,
  Images.cvarogel4,
  Images.cvarogel5,
  Images.cvarogel3,


];

// Function to group logos in chunks of 8 (4 per row, 2 rows)
const chunkLogos = (logos:any, chunkSize:any) => {
  const chunks = [];
  for (let i = 0; i < logos.length; i += chunkSize) {
    chunks.push(logos.slice(i, i + chunkSize));
  }
  return chunks;
};

const LogoCarousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Each slide contains 2 rows
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
  };

  const groupedLogos = chunkLogos(logos, 8); // Each slide will contain 8 logos

  return (
    <div className="carousel-container">
      <h2 className="carousel-title" >Our Valued Customers in GCC</h2>
      <Slider {...settings}>
        {groupedLogos.map((group, index) => (
          <div key={index} className="slide">
            <div className="logo-grid">
              {group.map((logo:any, i:any) => (
                <div key={i} className="logo-card">
                  <img src={logo} alt={`Logo ${i + 1}`} className="logo-image" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default LogoCarousel;
